import styled, { css } from 'styled-components'

const color = {
  green: '#5cb85c',
  red: '#d44b49',
  orange: '#f0ad4e',
  black: '#404040',
  grey: '#a1a1a1',
}

/**
 * @typedef {object} Props
 * @property {'green' | 'black' | 'grey' | 'red' | 'orange'} [disc]
 * @property {'normal' | 'medium'} [weight]
 */

/** @param {Props} props */
const withDiscStyles = props =>
  props.disc &&
  css`
    &::before {
      content: '';
      width: 10px;
      height: 10px;
      margin-right: 6px;

      display: inline-block;
      background-color: ${color[props.disc]};
      border-radius: 50%;
    }
  `

/** @param {Props} props */
const weightStyles = ({ weight = 'medium' }) => {
  switch (weight) {
    case 'medium':
      return 'Gotham-Medium'
    case 'normal':
    default:
      return 'Gotham'
  }
}

const Data = styled.span`
  display: inline-block;

  color: ${props => (props.color ? props.color : '#333333')};
  font-family: ${weightStyles};
  font-size: 14px;
  line-height: 14px;

  ${withDiscStyles}

  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`

export default Data



// WEBPACK FOOTER //
// ./src/lib/typography/Data.jsx